import { Translate } from "@phosphor-icons/react";
import clsx from "clsx";

import { getLanguageName } from "../../../../utils";
import FlowTypeLabel from "../../../FlowTypeLabel";

import type { CampaignFlow, CampaignFlowType } from "../../../../types";

export default function ReviewHeader({ flow }: { flow: CampaignFlow }) {
  let translateTitle = "OFF";
  if (flow.translate) {
    if (flow.source_language) {
      translateTitle = getLanguageName(flow.source_language);
      if (!flow.is_manual_language) {
        translateTitle += " (Detected)";
      }
    } else {
      translateTitle = "ON";
    }
  }

  const flowLabelOptions: Record<
    CampaignFlowType,
    {
      title: string;
      description: string;
    }
  > = {
    INMAIL_OPTIMIZATION: {
      title: "InMail Optimization",
      description: "Free InMail",
    },
    CONNECT_OPTIMIZATION: {
      title: "Connect Optimization",
      description: "Connect Optimization",
    },
    PRIMARY_MESSAGE: {
      title: flow.name,
      description: "A/B Split Test",
    },
    PRIMARY_CONNECT: {
      title: flow.name,
      description: "A/B Split Test",
    },
  };

  const { title, description } = flowLabelOptions[flow.type];

  return (
    <div className="flex gap-4 border-b border-black-200 bg-whiteGray p-4 max-md:flex-col md:items-center">
      <div className="flex gap-3">
        <FlowTypeLabel type={flow.type} />
        <div className="flex flex-col gap-1">
          <h3 className="text-lg-bold">{title}</h3>
          <p className="text-sm-medium text-black-500">{description}</p>
        </div>
      </div>

      <div
        className={clsx(
          "flex items-center gap-1 md:ml-auto",
          !flow.translate && "text-black-400",
        )}
      >
        <Translate weight="fill" size={20} />
        <p className="text-button-sm">
          Automatic translation <span>{translateTitle}</span>
        </p>
      </div>
    </div>
  );
}
